import { useEffect } from 'react';
import {
  Box,
  Grid,
  makeStyles,
  createStyles,
  IconButton
} from '@material-ui/core';
import { ChevronLeftOutlined } from '@material-ui/icons';
import { useSelector } from '@store';
import useDocuments from '@hooks/useDocuments';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { CreatePurchaseOrder } from '@components/Form/PurchaseOrder';

interface Props {
  rfqId?: string;
  partnerId?: string;
  chatRoomId?: string;
  quotationId?: string;
  onClose: () => void;
}
export default function PlacingAnOrder({
  rfqId,
  chatRoomId,
  partnerId,
  quotationId,
  onClose
}: Props): JSX.Element {
  const classes = useStyles();

  const { onUpdateDocumentsCurrentId } = useDocuments();

  const chatRoomStatus = useSelector(
    (state) => state.dashboard.selectedQuotationId?.chatRoomStatus
  );

  useEffect(() => {
    onUpdateDocumentsCurrentId({
      selectedQuotationId: quotationId
    });

    //eslint-disable-next-line
  }, [quotationId]);

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.header}>
        <IconButton onClick={onClose} className="header-btn">
          <ChevronLeftOutlined />
        </IconButton>
        <Box className="header-title">
          <CustomizedTypography
            variant="body1"
            fontWeight="500"
            color="textPrimary"
          >
            발주서 작성
          </CustomizedTypography>
        </Box>
      </Grid>
      <Grid item className={classes.content}>
        <CreatePurchaseOrder
          rfqId={rfqId}
          partnerId={partnerId}
          chatRoomId={chatRoomId}
          chatRoomStatus={chatRoomStatus}
          onCloseAtDashboard={onClose}
        />
      </Grid>
    </Grid>
  );
}

const LEFT_LIST_WIDTH = 375;
const HEADER_HEIGHT = 49;
const ICON_BUTTON_WIDTH = 48;
const FOOTER_HEIGHT = 83;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      height: '100%'
    },
    header: {
      position: 'fixed',
      width: `100%`,
      height: HEADER_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${colorSet.gray400}`,
      backgroundColor: colorSet.gray000,
      zIndex: 9,
      '& .header-btn': {
        color: colorSet.gray900
      },
      '& .header-title': {
        width: `calc(100% - ${LEFT_LIST_WIDTH}px - ${ICON_BUTTON_WIDTH}px)`,
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
          width: `calc(100% - ${ICON_BUTTON_WIDTH}px)`
        }
      }
    },
    content: {
      paddingTop: HEADER_HEIGHT,
      paddingBottom: FOOTER_HEIGHT,
      width: `100%`,
      backgroundColor: colorSet.gray000
    }
  })
);
